import { useDispatch } from 'react-redux'

import type { AppDispatch } from '../types'

function useAppDispatch() {
  return useDispatch<AppDispatch>()
}

export default useAppDispatch
